import React, { useEffect, useState } from "react";
import { Table } from "../DataTable";

const Analysis = props => {
    const [allRows, setAllRows] = useState([]);
    const [tasks, setTasks] = useState([]);

    useEffect(() => {
        setTasks(props.tasks ? props.tasks : []);
    }, [props.tasks]);

    useEffect(() => {
        const holder = {}, holder2 = [];
        props.rows.forEach(row => {
            if (holder.hasOwnProperty(row.label)) {
                // already has that label object
                holder[row.label] = {...holder[row.label],
                    segments: holder[row.label].segments + parseInt(row.segments),
                    words: holder[row.label].words + parseInt(row.words),
                    characters: holder[row.label].characters + parseInt(row.characters)
                }
            } else {
                holder[row.label] = {...row,
                    segments: parseInt(row.segments),
                    words: parseInt(row.words),
                    characters: parseInt(row.characters)
                };
            }
        });

        for (let key in holder) {
            holder2.push(holder[key]);
        }
        setAllRows(holder2);

    }, [props.rows]);

    const renderRow = (row, renderData) => {
        let label = row.label;
        label = label.replace("context", "101");
        label = label.replace("exact", "100");
        label = label.replace("fuzzy", "fuzzy (75-99)");

        return <React.Fragment>
            {renderData(label, { key: "label" })}
            {renderData(row.segments, { key: "segments" })}
            {renderData(row.words, { key: "words" })}
            {renderData(row.characters, { key: "characters" })}
        </React.Fragment>
    }

    return (
        <>
            <Table title="Summary" renderRow={renderRow} rows={allRows} cols={[
                { name: "label", sortCol: "label" },
                { name: "segments", sortCol: "segments" },
                { name: "words", sortCol: "words" },
                { name: "chars", sortCol: "characters" }
            ]} />
            {
                tasks.length > 1 && tasks.map(task => (
                    <Table title={`Task ${task}`} renderRow={renderRow}
                    rows={props.rows.filter(row => row.task_id === task)}
                    cols={[
                        { name: "label", sortCol: "label" },
                        { name: "segments", sortCol: "segments" },
                        { name: "words", sortCol: "words" },
                        { name: "chars", sortCol: "characters" }
                    ]} />
                ))
            }
        </>
    )
}

export default Analysis;